import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc = (isUsageBased) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  background: isUsageBased
    ? 'linear-gradient(167deg, #0E2E89 -2.47%, #1851EF 90.7%)'
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(3),
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(1),
  boxSizing: 'border-box',
  height: (p) => p.spacing(55.25),
});
